import { useQuery } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useGetPredictedOutcomeKey = 'get-predicted-outcome';

export const useGetPredictedOutcome = (enabled: boolean, caseGuid?: string) => {
    const { zoneApiClient } = useZoneContext();
    
    return useQuery({
        queryKey: [useGetPredictedOutcomeKey, caseGuid],
        queryFn: async () => {
            const response = await zoneApiClient.getCaseAssessmentPredictedOutcome(caseGuid ?? '');

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the predicted outcome for this case.');
            }
            return response.payload;
        },
        enabled: enabled && !!caseGuid,
        cacheTime: Infinity,
        staleTime: Infinity
    });
}